import { createFeatureSelector, createSelector } from "@ngrx/store";
import { WorldState } from "./world.state";

export const selectWorldState = createFeatureSelector<WorldState>("world");

export const selectWorldReady = createSelector(
  selectWorldState,
  (state: WorldState) => state.binstViewReady,
);

export const selectSurfaceDebug = createSelector(
  selectWorldState,
  (state: WorldState) => state.surfaceDebug,
);

export const selectWorldTick10s = createSelector(
  selectWorldState,
  (state: WorldState) => state.tickCount,
);

export const selectWorldDebuggers = createSelector(
  selectWorldState,
  (state: WorldState) => state.debuggers,
);